<header class="action-header action-header--with-status">
  <div class="action-header__container action-header__container--column">
    <div class="action-header__container">
      <h1 class="action-header__title">{{ title | ftrCapitalizeFirstLetter }}&nbsp;</h1>
      @if (count === 1) {
        <span class="action-header__status">1 {{ singular | ftrCapitalizeFirstLetter }}</span>
      }
      @if (count > 1) {
        <span class="action-header__status">{{ count }} {{ plural | ftrCapitalizeFirstLetter }}</span>
      }
    </div>
    <p class="action-header__summary">
      {{ summary }}
    </p>
    @if (filter) {
      <div>
        <span>{{ filter.title }}:</span>
        <ftr-filter
          [defaultValue]="filter.defaultFilterValue"
          [options]="filter.filterOptions"
          [filterKey]="filter.filterKey || 'live-table-layout-filter-key'"
          [singular]="filter.singular"
          [pageIdentifier]="filter.pageIdentifier || 'live-table-layout-page-identifier'"
          [skipLocalStorage]="true"
          [showActualDefault]="true"
          (filterChanged)="filter.setFilter($event, refresh)"
        >
        </ftr-filter>
      </div>
    }
  </div>
  <div class="action-container action-container-bottom">
    <ftr-live-action-bar
      [updateIntervalMs]="updateIntervalMs"
      [isSuccess]="isSuccess"
      [pauseUpdatesOnScroll]="pauseUpdatesOnScroll"
      (refresh)="refresh.emit()"
    >
    </ftr-live-action-bar>
  </div>
</header>
